// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';

import Icon from './Icon';

import styles from './IconStacked.less';

/** Component props for an IconStacked */
export type Props = {|
  /** The inner icon name */
  innerIcon: string,

  /** The outer icon name */
  outerIcon: string,

  /** Makes the icon appear active on hover */
  hover: boolean,

  /** Sets the icon to active. An active icon appears ta-green. */
  active: boolean,
|};

const IconStacked = ({ innerIcon, outerIcon, hover, active }: Props) => (
  <span
    className={classNames('ui_icon_stacked', styles.ui_icon_stacked, {
      [styles.hover]: hover,
    })}
  >
    <span className={styles.ui_icon_stacked_inner}>
      <Icon
        name={innerIcon}
        className={classNames('stacked', styles.innerIcon, {
          [styles.active]: active,
        })}
      />
      <Icon name={outerIcon} className={classNames('stacked', styles.outerIcon)} />
    </span>
  </span>
);

IconStacked.defaultProps = { hover: false, active: false };

export default IconStacked;
